import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-task-priority-definition',
  templateUrl: './task-priority-definition.component.html',
  styleUrls: ['./task-priority-definition.component.css']
})
export class TaskPriorityDefinitionComponent implements OnInit {

  form: any | FormGroup
  editForm: any | FormGroup
  taskPriorityData: any = []
  allData: any = []
  singleTaskPriority: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid: any
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  id: any = ""
  recordName: any = ""
  recordId: any = ""
  searchKey: any = ""

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllTaskPriorityDefinition()
    
    this.form = this.fb.group({
      priorityStatus: ['', [Validators.required]],
      timeInHrs: ['', [Validators.required, Validators.min(0)]],
      description: [''],
    })
    
    this.editForm = this.fb.group({
      priorityStatus: ['', [Validators.required]],
      timeInHrs: ['', [Validators.required, Validators.min(0)]],
      description: [''],
    })
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllTaskPriorityDefinition();
  }
  
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllTaskPriorityDefinition();
  }

  addTaskPriority() {
    if (!this.form.valid) {
      this.toastr.error("please fill required fields");
      return
    }

    const priorityStatus = this.form.get('priorityStatus').value?.trim();
    const timeInHrs = this.form.get('timeInHrs').value;
    const description = this.form.get('description').value?.trim();

    if (!priorityStatus) {
      this.toastr.error("Priority Status is required");
      return;
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": description || '',
      "id": "",
      "taskPriorityDefinitionId": 0,
      "priorityStatus": priorityStatus,
      "timeInHrs": timeInHrs,
      "cid": this.cid ? Number(this.cid) : 0
    }

    this.generic_service.addTaskPriorityDefinition(body).subscribe(
      (response: any) => {
        this.getAllTaskPriorityDefinition()
        this.cancelModel()
        this.form.reset()
        this.toastr.success(response.message || "Successfully Added")
      },
      (error: any) => {
        if(error?.error?.errors?.[0]?.description) {
            this.toastr.error(error.error.errors[0].description);
        } else {
            this.toastr.error("Error adding record");
        }
      }
    )
  }

  updateTaskPriority() {
    if (!this.editForm.valid) {
      this.toastr.error("please fill required fields");
      return
    }

    const priorityStatus = this.editForm.get('priorityStatus').value?.trim();
    const timeInHrs = this.editForm.get('timeInHrs').value;
    const description = this.editForm.get('description').value?.trim();

    let body = {
      ...this.singleTaskPriority[0],
      "description": description || '',
      "priorityStatus": priorityStatus,
      "timeInHrs": timeInHrs
    }

    this.generic_service.updateTaskPriorityDefinition(body).subscribe(
      (response: any) => {
        this.getAllTaskPriorityDefinition()
        this.cancelModel()
        this.editForm.reset()
        this.toastr.success(response.message || "Successfully Updated")
      },
      (error: any) => {
        if(error?.error?.errors?.[0]?.description) {
            this.toastr.error(error.error.errors[0].description);
        } else {
            this.toastr.error("Error updating record");
        }
      }
    )
  }

  formReset() {
    this.form.reset()
    this.editForm.reset()
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
  }

  getAllTaskPriorityDefinition() {
    this.isLoading = true

    this.generic_service.getAllTaskPriorityDefinition().subscribe(
      (res: any) => {
        this.allData = res.response || []
        this.taskPriorityData = res.response || []
        this.count = this.taskPriorityData.length
        this.isLoading = false
      },
      (err: any) => {
        console.log(err)
        this.isLoading = false
      }
    )
  }

  getTaskPriorityDefinitionById(id: any) {
    this.generic_service.getTaskPriorityDefinitionById(id).subscribe(
      (res: any) => {
        this.singleTaskPriority = []
        this.singleTaskPriority.push(res.response)
        this.editForm.patchValue({
          priorityStatus: res.response.priorityStatus,
          timeInHrs: res.response.timeInHrs,
          description: res.response.description,
        })
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  deleteTaskPriorityDefinition() {
    this.generic_service.deleteTaskPriorityDefinition(this.id).subscribe(
      (response: any) => {
        document.getElementById("deleteModalButton")?.click()
        this.toastr.success(response.message || "Successfully Deleted")
        this.getAllTaskPriorityDefinition()
        this.recordName = ""
        this.recordId = ""
      },
      (error: any) => {
        console.log(error)
        if(error?.error?.errors?.[0]?.description) {
            this.toastr.error(error.error.errors[0].description)
        } else {
            this.toastr.error("Error deleting record");
        }
      }
    )
  }

  selectDelete(id: any, record: any) {
    this.id = id;
    this.recordId = record.taskPriorityDefinitionId;
    this.recordName = record.priorityStatus;
  }

  closeModal() {
    this.recordId = "";
    this.recordName = "";
  }

  getAllByWildSearch() {
    if (this.searchKey == "" || this.searchKey == null) {
      this.taskPriorityData = this.allData
      this.count = this.allData.length
      return
    }
    
    const key = this.searchKey.toLowerCase();
    this.taskPriorityData = this.allData.filter((item: any) => 
        (item.priorityStatus && item.priorityStatus.toLowerCase().includes(key)) ||
        (item.description && item.description.toLowerCase().includes(key))
    );
    this.count = this.taskPriorityData.length;
  }

  refreshAll() {
    this.page = 1
    this.first = 0
    this.searchKey = ""
    this.getAllTaskPriorityDefinition()
  }
}
